import { Perf } from 'r3f-perf'
import Level from './Level.jsx'
import { Physics, Debug } from '@react-three/rapier'
import Player from './Player'
import useGame from './stores/useGame.jsx'



export default function Experience()
{
    const gamePlaying = useGame((state) =>  state)
    return <> 
        <Perf position="top-left" />
        <Physics>
            
            <Debug/>
            <Level />
            <Player/>
        </Physics>
        
    </>
}